import { providerService } from '@/api'
import active from './active'

const initialState = () => ({
  all: []
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async find ({ commit, state }, data) {
      try {
        if (state.all.length) return state.all
        const projects = await providerService.find({
          service: 'projects'
        })
        commit('assign', projects)
        return projects
      } catch (err) {
        console.error(err)
      }
    }
  },
  mutations: {
    assign (state, data) {
      state.all = data
    }
  },
  modules: {
    active
  }
}
